import { createFileRoute } from "@tanstack/react-router"
import DesignSystemEmptyState from "~/pages/design-system/components/EmptyState"

export const Route = createFileRoute("/_auth/internal/design-system/components/empty-state")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemEmptyState />
}
